import WalletButtons from '@/components/Wallet/WalletButtons';
import { useNavigation } from '@/context/NavigationContext';
import { useWidgetConfig } from '@/context/WidgetConfigContext';
import { COLORS } from '@/helpers/constants/theme';
import { E_AppRoutes } from '@/types/Routes';

export const PostRegistration = () => {
  const { navigateTo } = useNavigation();

  const { theme } = useWidgetConfig();

  const { textColor = COLORS.TEXT_INVERSE } = theme?.secondaryButton ?? {};

  return (
    <div className='py-8 text-center'>
      <div className='mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-green-100'>
        <div className='text-2xl text-green-600'>✅</div>
      </div>
      <h3 className='mb-2'>You're all set!</h3>
      <h6 className='mb-6'>Add your loyalty card to your wallet for quick access</h6>

      <div className='mt-6 space-y-3'>
        <WalletButtons />
      </div>

      <button
        onClick={() => navigateTo(E_AppRoutes.REGISTERED_CUSTOMER)}
        style={{
          color: textColor,
        }}
        className='secondary-button mt-4 w-full border-none bg-transparent outline-none transition-colors'
      >
        Continue to Dashboard
      </button>
    </div>
  );
};
